import { render, staticRenderFns } from "./Ferramentas.vue?vue&type=template&id=3053d238&scoped=true"
import script from "./Ferramentas.vue?vue&type=script&lang=js"
export * from "./Ferramentas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3053d238",
  null
  
)

export default component.exports